function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - License Details
 * 
 */
import * as React from 'react';
import LicenceAddress from '../../../components/licence-address/LicenceAddress';
import LicenceClass from '../../../components/licence-class/LicenceClass';
import LicenceExpiry from '../../../components/licence-expiry/LicenceExpiry';
import LicenceNumber from '../../../components/licence-number/LicenceNumber';
import LicenceScans from '../../../components/licence-scans/LicenceScans';
import StateOfIssue from '../../../components/state-of-issue/StateOfIssue';
import PhotoUpload from '../../../components/photo-upload/PhotoUpload';
import DeliveryMethod from '../../../components/delivery-method/DeliveryMethod';
import AcceptTerms from '../../../components/accept-terms/AcceptTerms';
import MarketingConsent from '../../../components/marketing-consent/MarketingConsent';
import Info from '../../../components/info/Info';
import { withRouter } from 'react-router-dom';
import './LicenceDetails.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SECTION = 'licence-details';
export class LicenceDetails extends React.Component {
  constructor(props) {
    super(props);
    // $FlowFixMe
    _defineProperty(this, "ref", void 0);
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    const {
      location
    } = this.props;
    if (location.hash === '#licence-details' && this.ref && this.ref.current) {
      setTimeout(() => {
        window.scrollTo({
          top: this.ref.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }, 500);
    }
    if (location.hash === '#store-selector') {
      setTimeout(() => {
        const storeSelector = document.getElementById('store-selector');
        if (storeSelector) {
          window.scrollTo({
            top: storeSelector.offsetTop - 100,
            behavior: 'smooth'
          });
        }
      }, 500);
    }
  }
  render() {
    const {
      bugsnagClient
    } = this.props;
    return /*#__PURE__*/_jsxs("section", {
      id: SECTION,
      ref: this.ref,
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Licence details"
      }), /*#__PURE__*/_jsx("div", {
        className: "preamble",
        children: /*#__PURE__*/_jsx(LicenceScans, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: "photo-uploads",
        children: [/*#__PURE__*/_jsx(PhotoUpload, {
          bugsnagClient: bugsnagClient,
          name: 'licenceFront',
          chooserTextDefault: 'Upload front of licence',
          disableAspectRatio: true
        }), /*#__PURE__*/_jsx(PhotoUpload, {
          bugsnagClient: bugsnagClient,
          name: 'licenceBack',
          chooserTextDefault: 'Upload back of licence',
          disableAspectRatio: true
        }), /*#__PURE__*/_jsx("div", {
          className: "spacer"
        }), /*#__PURE__*/_jsx(Info, {
          info: " Check that your photo clearly shows all details, including the number on the back and front of licence.",
          icon: "id-card"
        })]
      }), /*#__PURE__*/_jsx(LicenceNumber, {}), /*#__PURE__*/_jsx(LicenceClass, {}), /*#__PURE__*/_jsx(LicenceExpiry, {}), /*#__PURE__*/_jsx(StateOfIssue, {}), /*#__PURE__*/_jsx(LicenceAddress, {
        bugsnagClient: bugsnagClient
      }), /*#__PURE__*/_jsx("h2", {
        children: "Delivery method"
      }), /*#__PURE__*/_jsx(DeliveryMethod, {}), /*#__PURE__*/_jsx(AcceptTerms, {}), /*#__PURE__*/_jsx(MarketingConsent, {})]
    });
  }
}
_defineProperty(LicenceDetails, "defaultProps", {
  location: {
    pathname: '',
    search: '',
    hash: ''
  }
});
export default withRouter(LicenceDetails);